module.exports = __webpack_public_path__ + "img/aivideo.f5b7fddb.png";